import { css } from '@emotion/react';
import { colors } from '@toilet-paper-games/ui';

export interface CornerBadgeProps {
  children: React.ReactNode;
  className?: string;
}

// Only for bottom right corner currently
export const CornerBadge = (props: CornerBadgeProps) => {
  const { children, className } = props;

  return (
    <div css={ribbonWrapStyle}>
      <div className={className} css={ribbonStyle}>
        {children}
      </div>
    </div>
  );
};

const ribbonWrapStyle = css({
  position: 'absolute',
  bottom: 0,
  right: 0,
  transform: 'rotate(-45deg)',
  transformOrigin: 'top left',
});

const ribbonStyle = css({
  fontSize: 10,
  background: colors.danger,
  color: 'white',

  transform: 'translateX(6px)',
  // transformOrigin: 'top left',
  '&:before,&:after': {
    content: "''",
    position: 'absolute',
    top: 0,
    margin: '0 -1px',
    width: '100%',
    height: '100%',
    background: colors.danger,
  },
  '&:before': { right: '100%' },
  '&:after': { left: '100%' },
});
